module.exports = __webpack_public_path__ + "fonts/Baloo2-ExtraBold.17c8015.ttf";